import LocationPanels from "./LocationPanels";
import React from "react";
import {useQuery} from "@tanstack/react-query";
import {getCallDetails} from "../api/calls";
import Maps from "./Maps";

const Tabs = ({isOpen, callUuid}) => {
    const {isError, data: response} = useQuery({
        queryKey: ["get-call-detail-" + callUuid, {callUuid}],
        queryFn: getCallDetails,
        enabled: isOpen,
        refetchInterval: 10000, // refetch every 10 sec,
        refetchIntervalInBackground: true
    });

    if (!isOpen) return null;
    if (isError || !response?.length) return <div className="call-details">
        <section className="map-panel empty-map" role={isError ? "alert" : "status"}>
            {isError ? "Unable to load call details. Please try again." : "Loading call…"}
        </section>
        <LocationPanels>
            <section className="location-panel"><h2 className="panel-title">Current Location</h2></section>
            <section className="history-panel"><h2 className="panel-title">History</h2></section>
        </LocationPanels>
    </div>;

    response[0].eml.forEach(callPushData => {
        let payload = callPushData.payload;
        const hasResolvedLocations = !!(payload && payload.length && payload[0].rankedLocations.length);
        // sort by confidence
        if (hasResolvedLocations) {
            payload[0].rankedLocations.sort((l1, l2) => l1.confidence > l2.confidence ? -1 : 1);
        }
    });

    const mostRecentCallPush = response[0].eml && response[0].eml.length ? response[0].eml[0] : {payload: [{rankedLocations: [{}]}]};

    return (
        <>
            <div className="selected-call-details">
                <Maps
                    topEmlLocation={mostRecentCallPush.payload[0]}
                    callUuid={callUuid}
                    history={response[0].eml}
                />
            </div>
        </>
    );
};

export default Tabs;
